import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex } from '@magnetic/flex';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import NatsClient from '../../../../store/natsclient';
import BrandLogo from '../../common/brand-logo';
import { TelemetryWidget } from '../../common/telemetry-widget';
import FloorInfo from '../components/floor-info';
import Header from '../components/header';
import Footer from '../components/footer';
import Line from '../components/line/index.styled';
import MapComponent from '../components/map/index';
import FloorLayout from './floor-layout';
import { MapProvider } from './MapContext';
import WebGLModal from './web-gl-modal';
import { NavigateOnPhone } from '../components/navigate-on-phone';
import RoomDetailsPopup, { closeRoomDetailsPopup, } from '../components/room-details-popup';
import { setViewType } from '../../../../store/authslice';
import { getSelectedLocation, setSelectedLocation, } from '../../redux/spaces-slice';
import { getDestinationRichMapId, getRoomSearchPopUpOpen, getUIState, setRoomDetailsPopUp, setRoomFinderOpen, setRoomSearchPopUp, } from '../../../../store/uislice';
import { store } from '../../../../store/store';
import { getOccupancyStatus, POI_TYPES_ORIGINAL, resolveActiveFloorLocation, } from '../util';
import { getLocation, selectFloorById, getRoomAnalytics, } from '../../redux/spaces-slice';
import { getContext } from '../../redux/spaces-slice';
import { hasValue } from '../../navigator/util';
import './index.scss';
import Time from '../../common/time';
import MapContainer from '../components/map/map-container.styled';
import { RoomSearchPopup } from '../components/room-search-popup';
import InactivityPopup from '../components/inactive-timeout';
import HowToUseThis from '../components/how-to-use-this';
import CountsWidget from '../components/counts-widget';
const BrandLogoContainer = styled.div `
  width: 10.3vw;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
`;
const TopSummaryCard = styled(Flex) `
  background-color: #1f2226;
  width: fit-content;
  max-width: 34vw;
  height: 9vh;
  border-radius: 1.2vw;
  margin: 1vw 0.4vw 1.2vw 1.2vw;
  gap: 1vw;
  display: inline-block;
  flex: 1 1 100vw;
  box-sizing: border-box;

  @media (orientation: portrait) {
    height: 10vw;
    min-height: 10vw;
  }
`;
const TimeContainer = styled.div `
  background: #272a2f;
  height: 4.8vw;
  margin-top: 1.4vw;
  padding: 1vw;
  border-radius: 0.6vw;
  position: fixed;
  right: 12vw;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;

  @media (orientation: portrait) {
    right: 1vh;
    margin-top: 0.8vw;
    height: 10.6vw;
    min-height: 10.6vw;
  }
`;
const FloorView = ({ id }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const dispatch = useDispatch();
    const locationData = useSelector(getLocation);
    const contextInfo = useSelector(getContext);
    const { floorLocationId, floorLocationData } = resolveActiveFloorLocation(locationData, contextInfo, id !== null && id !== void 0 ? id : '');
    const floorAnalyticsCurrentFloor = useSelector((state) => selectFloorById(state, floorLocationId !== null && floorLocationId !== void 0 ? floorLocationId : ''));
    const airQuality = (_a = floorAnalyticsCurrentFloor === null || floorAnalyticsCurrentFloor === void 0 ? void 0 : floorAnalyticsCurrentFloor.airQuality) !== null && _a !== void 0 ? _a : null;
    const ambientTemp = (_b = floorAnalyticsCurrentFloor === null || floorAnalyticsCurrentFloor === void 0 ? void 0 : floorAnalyticsCurrentFloor.ambientTemp) !== null && _b !== void 0 ? _b : null;
    const co2 = (_c = floorAnalyticsCurrentFloor === null || floorAnalyticsCurrentFloor === void 0 ? void 0 : floorAnalyticsCurrentFloor.co2) !== null && _c !== void 0 ? _c : null;
    const peopleCount = (_d = floorAnalyticsCurrentFloor === null || floorAnalyticsCurrentFloor === void 0 ? void 0 : floorAnalyticsCurrentFloor.peopleCount) !== null && _d !== void 0 ? _d : null;
    const capacity = (_e = floorAnalyticsCurrentFloor === null || floorAnalyticsCurrentFloor === void 0 ? void 0 : floorAnalyticsCurrentFloor.capacity) !== null && _e !== void 0 ? _e : null;
    const relativeHumidity = (_f = floorAnalyticsCurrentFloor === null || floorAnalyticsCurrentFloor === void 0 ? void 0 : floorAnalyticsCurrentFloor.relativeHumidity) !== null && _f !== void 0 ? _f : null;
    const occupancyStatus = getOccupancyStatus(peopleCount, capacity);
    const appConfigFloor = (_g = contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.appConfig) === null || _g === void 0 ? void 0 : _g.floor;
    const showAirQuality = appConfigFloor === null || appConfigFloor === void 0 ? void 0 : appConfigFloor.showAirQuality;
    const showCO2 = appConfigFloor === null || appConfigFloor === void 0 ? void 0 : appConfigFloor.showCO2;
    const showFloorOccupancy = appConfigFloor === null || appConfigFloor === void 0 ? void 0 : appConfigFloor.showFloorOccupancy;
    const showHumidity = appConfigFloor === null || appConfigFloor === void 0 ? void 0 : appConfigFloor.showHumidity;
    const showTemperature = appConfigFloor === null || appConfigFloor === void 0 ? void 0 : appConfigFloor.showTemperature;
    const [isFirstPopup, setIsFirstPopup] = useState(true);
    const interactive = contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.interactive;
    const showPOIs = (_j = (_h = contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.appConfig) === null || _h === void 0 ? void 0 : _h.floor) === null || _j === void 0 ? void 0 : _j.showPOI;
    const shouldShowWhereAmI = 'isWhereAmIEnabled' in contextInfo &&
        (contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.isWhereAmIEnabled) !== null
        ? contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.isWhereAmIEnabled
        : (contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.deviceLocationId) !== null;
    const isWayFindingEnabled = contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.isWayFindingEnabled;
    const destinationRichMapId = useSelector(getDestinationRichMapId);
    const { tenantId, buildingLocationId, zoom, mapCenterLatLng, pitch, bearing, modelWithScreen = true, deviceLatLng, rotateAngle, deviceLocationId, } = contextInfo;
    const buildingName = locationData === null || locationData === void 0 ? void 0 : locationData.name;
    const floorNumber = floorLocationData === null || floorLocationData === void 0 ? void 0 : floorLocationData.floorNumber;
    const floorName = floorLocationData === null || floorLocationData === void 0 ? void 0 : floorLocationData.name;
    const deviceLocationFloorNumber = (_l = (_k = locationData === null || locationData === void 0 ? void 0 : locationData.children) === null || _k === void 0 ? void 0 : _k.find((child) => child.id === deviceLocationId)) === null || _l === void 0 ? void 0 : _l.floorNumber;
    const floorNumberIdMap = {};
    // TODO Optimize below subscription
    useEffect(() => {
        var _a;
        if ((locationData === null || locationData === void 0 ? void 0 : locationData.id) && floorLocationId) {
            console.log('Initiating subscriptions  in floor');
            const subject = `signageAnalytical.${locationData.id}.${floorLocationId}.*`;
            console.log('Floor view subject :: ', subject);
            NatsClient.subscribe([subject]);
            for (const floorNumber of (_a = locationData === null || locationData === void 0 ? void 0 : locationData.children) !== null && _a !== void 0 ? _a : []) {
                floorNumberIdMap[floorNumber.floorNumber] = floorNumber.id;
            }
        }
    }, [floorLocationId, locationData.id]);
    useEffect(() => {
        const webGL = (() => {
            try {
                const canvas = document.createElement('canvas');
                return !!(canvas.getContext('webgl') || canvas.getContext('experimental-webgl'));
            }
            catch (e) {
                return false;
            }
        })();
        setHasWebGLSupport(webGL);
    }, []);
    const content = () => (_jsxs(Flex, Object.assign({ style: {
            gap: '1vw',
            width: '99.2vw',
        } }, { children: [_jsx(TopSummaryCard, Object.assign({ direction: "horizontal", grow: true, basis: 1250, justify: "center" }, { children: _jsxs(Flex, Object.assign({ align: "center", style: {
                        alignItems: 'center',
                        display: 'flex',
                        flex: '0 1 auto',
                        flexFlow: 'row',
                        gap: '1vw',
                        justifyContent: 'flex-start',
                        margin: '1vw 0',
                        width: 'fit-content',
                    } }, { children: [_jsx(BrandLogoContainer, { children: _jsx(BrandLogo, {}) }), _jsx(Line, { orientation: "vertical" }), _jsx(FloorInfo, { floorId: floorLocationId, building: buildingName, floor: floorName, selectFloor: (floorId) => {
                                if (String(floorId).toLowerCase() === 'all') {
                                    dispatch(setSelectedLocation(''));
                                    // toggle back to building
                                }
                                else {
                                    dispatch(setSelectedLocation(String(floorId)));
                                }
                            } })] })) })), _jsxs(Flex, Object.assign({ direction: "horizontal", justify: "space-between" }, { children: [showFloorOccupancy &&
                        hasValue(getOccupancyStatus(peopleCount, capacity)) && (_jsx(Flex, Object.assign({ align: "center", style: { margin: '0vw 0.2vw' }, id: "floor-occupancy" }, { children: _jsx(TelemetryWidget, { type: 'OCCUPANCY', status: occupancyStatus, size: 'xsm' }) }))), showAirQuality && hasValue(airQuality) && (_jsx(Flex, Object.assign({ align: "center", style: { margin: '0.4vw' }, id: "floor-iaq" }, { children: _jsx(TelemetryWidget, { type: 'IAQ', status: airQuality, size: 'xsm' }) }))), showCO2 && hasValue(co2) && (_jsx(Flex, Object.assign({ align: "center", style: { margin: '0.4vw' }, id: "floor-co2" }, { children: _jsx(TelemetryWidget, { type: 'CO2', status: co2, size: 'xsm' }) }))), showTemperature && hasValue(ambientTemp) && (_jsx(Flex, Object.assign({ align: "center", style: { margin: '0.4vw' }, id: "floor-temperature" }, { children: _jsx(TelemetryWidget, { type: 'TEMPERATURE', status: ambientTemp, size: 'xsm' }) }))), showHumidity && hasValue(relativeHumidity) && (_jsx(Flex, Object.assign({ align: "center", style: { margin: '0.4vw' }, id: "floor-humidity" }, { children: _jsx(TelemetryWidget, { type: 'HUMIDITY', status: relativeHumidity, size: 'xsm' }) })))] })), _jsx(TimeContainer, { children: _jsx(Time, {}) }), _jsx(HowToUseThis, {})] })));
    const mapDetails = {
        map: {
            tenantId: tenantId,
            buildingId: buildingLocationId,
            zoom: zoom,
            long: mapCenterLatLng[1],
            lat: mapCenterLatLng[0],
            pitch: pitch,
            bearing: bearing,
            floorNumber: Number(floorNumber),
            floorLocation: floorNumber,
        },
        device: {
            modelWithScreen: modelWithScreen,
            deviceLocation: deviceLocationFloorNumber,
            long: deviceLatLng && deviceLatLng[1],
            lat: deviceLatLng && deviceLatLng[0],
            xAngle: rotateAngle && rotateAngle[0],
            yAngle: rotateAngle && rotateAngle[1],
            zAngle: rotateAngle && rotateAngle[2],
        },
    };
    const [hasWebGLSupport, setHasWebGLSupport] = useState(true);
    const showRoomDetailsPopup = (richMapId) => {
        store.dispatch(setRoomDetailsPopUp({ payload: richMapId }));
    };
    const getRoomAvailabilityForHighlighting = (roomsData) => {
        var _a, _b, _c, _d;
        const roomAvailability = {};
        for (const room in roomsData) {
            if (!roomsData[room] || !((_a = roomsData[room]) === null || _a === void 0 ? void 0 : _a.availability))
                continue;
            const availabilityStatus = ((_b = roomsData[room]) === null || _b === void 0 ? void 0 : _b.availability) === 'noData'
                ? 'Unknown'
                : (_c = roomsData[room]) === null || _c === void 0 ? void 0 : _c.availability;
            roomAvailability[room] = {
                availability: availabilityStatus,
                richMapId: (_d = roomsData[room]) === null || _d === void 0 ? void 0 : _d.richMapId,
            };
        }
        return roomAvailability;
    };
    const roomsData = useSelector(getRoomAnalytics);
    const roomAvailability = useMemo(() => getRoomAvailabilityForHighlighting(roomsData), [roomsData]);
    const deskAvailability = useMemo(() => ({}), []);
    const showRoomSearchPopup = useSelector(getRoomSearchPopUpOpen);
    /***********inactivity-popup-logic***********/
    const INACTIVITY_TIMEOUT = 240; // In seconds
    const RESET_TIMER = 30; // In seconds
    const CHECK_INTERVAL = 10; // In seconds, lesser the check interval, higher the accuracy, but more freq checking of (currenTime - lastTouch) diff
    const UPDATE_LAST_TOUCH = 10; // In seconds, to update last touch when dirty itself is false, (so need to render popup)
    const [showInactivityPopup, setShowInactivityPopup] = useState(false);
    const [isDirty, setIsDirty] = useState(false);
    const lastTouchRef = useRef(null);
    const intervalCheckerRef = useRef(null);
    const selectedFloor = useSelector(getSelectedLocation);
    const isCurrViewTypeBuilding = !selectedFloor || selectedFloor.trim() === '';
    const updateLastTouch = () => {
        lastTouchRef.current = Date.now();
        setIsDirty(true);
    };
    useEffect(() => {
        const intervalId = setInterval(() => {
            if (!isDirty) {
                lastTouchRef.current = Date.now();
            }
        }, UPDATE_LAST_TOUCH * 1000);
        return () => clearInterval(intervalId);
    }, [isDirty]);
    useEffect(() => {
        updateLastTouch();
        setShowInactivityPopup(false);
        window.addEventListener('mousemove', updateLastTouch);
        window.addEventListener('touchmove', updateLastTouch);
        intervalCheckerRef.current = setInterval(() => {
            // Interval checker runs every 'CHECK_INTERVAL' seconds to perform check on lastTouch update
            if (lastTouchRef.current &&
                Date.now() - lastTouchRef.current >= INACTIVITY_TIMEOUT * 1000)
                setShowInactivityPopup(true);
        }, CHECK_INTERVAL * 1000);
        return () => {
            // cleanup on dismount
            if (intervalCheckerRef.current)
                clearInterval(intervalCheckerRef.current);
            window.removeEventListener('mousemove', updateLastTouch);
            window.removeEventListener('touchmove', updateLastTouch);
        };
    }, [isCurrViewTypeBuilding]);
    // Device location Id should be a valid id (it must be present in the children array)
    const deviceLocationIdIsInChildren = (deviceLocationId) => {
        return locationData === null || locationData === void 0 ? void 0 : locationData.children.some((child) => (child === null || child === void 0 ? void 0 : child.id) === deviceLocationId);
    };
    deviceLocationIdIsInChildren(contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.deviceLocationId);
    const resetViewHandler = () => {
        const isBuilding = (contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.viewType) === 'building';
        // If Where-Am-I is enabled, go to where-am-I floor
        if ((contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.deviceLocationId) &&
            shouldShowWhereAmI &&
            deviceLocationIdIsInChildren(contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.deviceLocationId)) {
            // If current floor is not the Where-Am-I floor, switch to Where-Am-I floor
            closeRoomDetailsPopup();
            if (id !== deviceLocationId)
                dispatch(setSelectedLocation(deviceLocationId));
            // Else just reset view
        }
        // If Where-Am-I is disabled
        else {
            // If building view signage, go to building view
            if (isBuilding) {
                dispatch(setSelectedLocation(''));
                dispatch(setViewType('building'));
            }
            else {
                // If floor view signage, reset floor view
                closeRoomDetailsPopup();
                window.rMap.reset();
            }
        }
        // Clear the POIs selections
        setTimeout(() => {
            if (window.rMap) {
                window.rMap.reset();
                for (const type of POI_TYPES_ORIGINAL) {
                    window.rMap.updatePoiSelection(type, true);
                }
            }
        }, 400);
        setShowInactivityPopup(false);
        setIsDirty(false);
        lastTouchRef.current = Date.now();
        window.rMap.reset();
        store.dispatch(setRoomFinderOpen({ payload: false }));
        store.dispatch(setRoomSearchPopUp({ payload: false }));
    };
    const continueHandler = () => {
        setShowInactivityPopup(false);
        lastTouchRef.current = Date.now();
    };
    /*******************************************/
    const richMapId = (_m = useSelector(getUIState)) === null || _m === void 0 ? void 0 : _m.popupRichMapID;
    // if (!floorLocationId) {
    //   return <div style={{ width: '100%', height: '100%' }} />; // or a placeholder
    // }
    if (!contextInfo || Object.keys(contextInfo).length === 0) {
        dispatch(setViewType('building'));
        return null;
    }
    return (_jsxs(FloorLayout, { children: [showInactivityPopup && isDirty && !isCurrViewTypeBuilding && (_jsx(InactivityPopup, { maxTime: RESET_TIMER, continueHandler: continueHandler, resetViewHandler: resetViewHandler })), !hasWebGLSupport && _jsx(WebGLModal, {}), hasWebGLSupport && (_jsxs(MapProvider, { children: [_jsxs("div", Object.assign({ style: { zIndex: '', position: 'fixed' } }, { children: [_jsx(MapContainer, { id: "map-v2", className: "map-container", style: {
                                    position: 'fixed',
                                    top: 0,
                                    left: 0,
                                    zIndex: 0,
                                    width: '100vw',
                                    height: '100vh',
                                } }), _jsx(MapComponent, { mapDetails: mapDetails, showRoomDetailsPopup: showRoomDetailsPopup, roomAvailability: roomAvailability, deskStatus: deskAvailability, showPOI: showPOIs })] })), _jsx("div", Object.assign({ className: "left-panel" }, { children: _jsx(CountsWidget, { floorId: floorLocationId, forRooms: true }) })), showRoomSearchPopup && (_jsx(RoomSearchPopup, { floorId: floorLocationId, onClose: () => store.dispatch(setRoomSearchPopUp({ payload: false })) }))] })), _jsx(Header, { children: content() }), isWayFindingEnabled && _jsx(NavigateOnPhone, {}), _jsx(Footer, {}), richMapId && _jsx(RoomDetailsPopup, { floorId: floorLocationId })] }));
};
export default FloorView;
